import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormBuilderContext } from '../../formContext';

/**
 * Tokens offered in a field's `@` list. Goal tokens are offered inside a goal
 * section, and on any field with Goal Mode (`properties.goalMode`) on, provided
 * the form model has goal tokens at all. Target tokens are added on a Goal Mode
 * table with Target Mode (`properties.targetMode`) on.
 */
export const useMentionOptions = ({ noMentions, activeSection, goalMode, targetMode } = {}) => {
    const context = useContext(FormBuilderContext);
    const formList = context?.formList;
    const formSettings = useSelector((state) => state.forms.formSettings);
    const formMeta = formSettings?.defaultValuesMeta?.[formList?.model];
    const currentSection = formList?.sections?.[(activeSection || 1) - 1];

    if (noMentions) return [];

    if (!formList?.model || !formMeta) return [];

    if (currentSection?.goalSection) {
        return [...(formMeta?.general || []), ...(formMeta?.goal || []), ...(formMeta?.target || [])];
    }
    if (!goalMode) return [...(formMeta?.general || [])];
    return [...(formMeta?.general || []), ...(formMeta?.goal || []), ...(targetMode ? formMeta?.target || [] : [])];
};
